import React, { useState } from "react";
import {
  Box,
  Card,
  TextField,
  Typography,
  Grid,
  Button,
} from "@mui/material";

const KeywordForm = () => {
  const [form, setForm] = useState({
    shortcode: "",
    keyword: "",
    period: "",
    key_valid_till: "",
    forward_to_email: "",
    forward_to_mobile: "",
    key_response: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    console.log("Form Data:", form);
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        bgcolor: "#f5f5f5",
        p: 4,
      }}
    >
      <Card sx={{ width: "100%", maxWidth: 700, p: 4, borderRadius: 3 }}>
        <Typography variant="h5" fontWeight={600} mb={3} textAlign="center">
          Create Keyword
        </Typography>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Shortcode"
              name="shortcode"
              fullWidth
              value={form.shortcode}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              label="Keyword"
              name="keyword"
              fullWidth
              value={form.keyword}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              type="number"
              label="Period (Days)"
              name="period"
              fullWidth
              value={form.period}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              type="date"
              label="Key Valid Till"
              name="key_valid_till"
              fullWidth
              InputLabelProps={{ shrink: true }}
              value={form.key_valid_till}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              type="email"
              label="Forward to Email"
              name="forward_to_email"
              fullWidth
              value={form.forward_to_email}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              type="text"
              label="Forward to Mobile"
              name="forward_to_mobile"
              fullWidth
              value={form.forward_to_mobile}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="Key Response"
              name="key_response"
              fullWidth
              multiline
              minRows={3}
              value={form.key_response}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12} mt={1}>
            <Button
              fullWidth
              variant="contained"
              sx={{ py: 1.2, fontWeight: 600 }}
              onClick={handleSubmit}
            >
              Create Keyword
            </Button>
          </Grid>
        </Grid>
      </Card>
    </Box>
  );
};

export default KeywordForm;
